import { useMemo } from 'react';
import VastPlayer from './VastPlayer';

interface Props {
  responseJson: string;
  creativeType: 'banner' | 'video' | 'native' | 'audio';
}

function findAdm(json: any): string | undefined {
  if (!json) return;
  if (json.seatbid && Array.isArray(json.seatbid) && json.seatbid.length) {
    const bidArr = json.seatbid[0]?.bid;
    if (Array.isArray(bidArr) && bidArr.length) {
      return bidArr[0]?.adm;
    }
  }
  return undefined;
}

export default function ResponsePreview({ responseJson, creativeType }: Props) {
  const { adm, vastXml, nativeObj, error } = useMemo(() => {
    if (!responseJson) return { adm: '', vastXml: '', nativeObj: null, error: null };
    try {
      const parsed = JSON.parse(responseJson);
      const adm = findAdm(parsed) || '';
      if (creativeType === 'banner') return { adm, vastXml: '', nativeObj: null, error: null };
      if (creativeType === 'video' || creativeType === 'audio') return { adm, vastXml: adm, nativeObj: null, error: null };
      if (creativeType === 'native') {
        let nativeObj = null;
        try {
          nativeObj = adm ? JSON.parse(adm) : null;
        } catch {
          nativeObj = null;
        }
        return { adm, vastXml: '', nativeObj, error: null };
      }
      return { adm, vastXml: '', nativeObj: null, error: null };
    } catch (e: any) {
      return { adm: '', vastXml: '', nativeObj: null, error: e.message || String(e) };
    }
  }, [responseJson, creativeType]);

  // Banner
  if (creativeType === 'banner' && adm) {
    return (
      <div>
        <div style={{
          border: '1px solid #bbb',
          borderRadius: 4,
          overflow: 'hidden',
          width: '100%',
          minHeight: 200,
          margin: '0 auto',
          background: '#fff'
        }}>
          <iframe
            title="Banner Creative"
            sandbox="allow-popups"
            style={{ width: '100%', height: 350, border: 'none', background: 'white', display: 'block' }}
            srcDoc={adm}
          />
        </div>
      </div>
    );
  }

  if (creativeType === 'video' && vastXml) {
    return <VastPlayer vastXml={vastXml} kind="video" />;
  }

  if (creativeType === 'audio' && vastXml) {
    return <VastPlayer vastXml={vastXml} kind="audio" />;
  }

  if (creativeType === 'native' && nativeObj) {
    let title = '';
    let img = '';
    let data = '';
    let cta = '';
    let sponsored = '';
    if (Array.isArray((nativeObj as any).assets)) {
      for (const a of (nativeObj as any).assets) {
        if (a.title?.text) title = a.title.text;
        if (a.img?.url) img = a.img.url;
        if (a.data && typeof a.data.value === 'string') {
          if (a.data.type === 1) sponsored = a.data.value;
          else data = a.data.value;
        }
        if (a.data && a.data.type === 12) cta = a.data.value;
      }
    }
    return (
      <div style={{
        background: '#fafbfc',
        border: '1px solid #eee',
        borderRadius: 6,
        padding: 20,
        width: '100%',
        maxWidth: 520,
        margin: '0 auto'
      }}>
        {img && <img src={img} alt="" style={{ maxWidth: '100%', borderRadius: 4, marginBottom: 12 }} />}
        <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 4 }}>{title}</div>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 4 }}>{sponsored}</div>
        <div style={{ marginBottom: 8 }}>{data}</div>
        {cta && (
          <button style={{ border: 'none', background: '#1677ff', color: '#fff', borderRadius: 4, padding: '7px 16px', cursor: 'pointer' }}>{cta}</button>
        )}
      </div>
    );
  }

  return (
    <div>
      <span style={{ color: '#888' }}>No creative found or unsupported format.</span>
      {error && <pre style={{ color: 'red' }}>{error}</pre>}
    </div>
  );
}
